import { Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const ghostClass =
  "text-zinc-200 hover:bg-white/10 hover:text-white disabled:opacity-50";

export function ApprovalSelectionBar({
  count,
  onClear,
  onApprove,
  onReject,
  canApprove = true,
  canReject = true,
}) {
  const open = count > 0;

  return (
    <div
      className="selection-bar selection-bar-stack surface-frost-ink"
      data-open={open ? "true" : "false"}
      role="toolbar"
      aria-label="Selected approval requests"
      aria-hidden={!open}
      inert={!open}
    >
      <span data-dock-count className="pe-2 text-sm font-medium text-white" aria-live="polite">
        <span className="num">{count}</span> selected
      </span>
      {canApprove && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onApprove}
          className={`rounded-[0.8rem] font-semibold text-emerald-200 hover:bg-white/10 hover:text-emerald-100 ${ghostClass}`}
        >
          <Check data-icon="inline-start" />
          Approve
        </Button>
      )}
      {canReject && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onReject}
          className={`rounded-[0.8rem] font-semibold text-red-200 hover:bg-white/10 hover:text-red-100 ${ghostClass}`}
        >
          <X data-icon="inline-start" />
          Reject
        </Button>
      )}
      <Button type="button" variant="ghost" size="sm" onClick={onClear} className={ghostClass}>
        Clear
      </Button>
    </div>
  );
}
